/** @jsx isolateComponent */
import { css } from '@emotion/core';

import { Colors, Typography } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

import { rebrandFocusCss } from '../../../styles';

const skipCss = css`
  width: 100%;
  border: 1px solid ${Colors.GrayWarm4};
  background-color: ${Colors.GrayWarm2};
  border-radius: 5px;
  padding: 15px;
  ${Typography.SmallPrint3}
  ${rebrandFocusCss}
  &:hover,
  &:focus {
    background-color: ${Colors.UiPrimaryWeakest};
    border-color: ${Colors.UiPrimaryWeakest};
    color: ${Colors.UiPrimaryStrongest};
  }
`;

type SkipButtonProps = {
  /** Text to display */
  children: string;
  /** Function that will be called with `null` on click */
  onSelect: (item: null) => void;
};

/** Button as used in `<AppBlock>` and `<ZapBlock>` to skip the question. */
const SkipButton = ({ children, onSelect }: SkipButtonProps) => {
  return (
    <button css={skipCss} onClick={() => onSelect(null)}>
      {children}
    </button>
  );
};

export default SkipButton;
